export default __webpack_public_path__ + "static/media/6.d5d3e63e.jpg";